<template>
    <div>
        <div v-if="!editing" :class="reactiveClass">
            <b-link title="Cliquer pour modifier" @click="edit">
                {{ initials }}
            </b-link>
        </div>
        <div v-if="editing">
            <b-input-group>
                <b-input-group-prepend>
                    <b-button title="Annuler" size="sm" @click="display">
                        <i class="fas fa-fw fa-times"></i>
                    </b-button>
                </b-input-group-prepend>
                <b-select
                    v-model="form.accounting_firm_user_id"
                    size="sm"
                    :options="options"
                    @change="store"
                />
            </b-input-group>
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../common/mixins/TableFormHandler'

export default {
    name: 'TableRoleCreator',

    mixins: [TableFormHandler],
    props: {
        client: null,
        roleOption: '',
    },
    data() {
        return {
            editing: false,
            initials: '-',
            form: {},
            options: [],
        }
    },

    methods: {
        async edit() {
            await this.getOptions()
            this.editing = true
        },

        display() {
            this.editing = false
        },

        async getOptions() {
            try {
                const response = await axios.get(
                    `/collaboratorsFromCompany/${this.client.accounting_firm_company.id}/initials`
                )
                this.options = response.data.data
            } catch (error) {
                console.log(error)
            }
        },

        async store() {
            this.form.client_id = this.client.id
            this.form.role_option = this.roleOption
            try {
                await axios.post('/roleAssignments', this.form)
                this.handleSuccess()
                this.setInitials()
                this.display()
            } catch (error) {
                this.initForm()
                this.display()
                this.handleError()
                console.log(error)
            }
        },

        setInitials() {
            const selectedOption = this.options.find(
                (item) => item.value === this.form.accounting_firm_user_id
            )
            this.initials = selectedOption.text
        },
    },
}
</script>

<style scoped></style>
